import React from 'react';
import { Link } from 'react-router-dom';

const TicketItem = (props) => {
    return (
        <Link to={`/Tickets/InnerPage/${props.data.id}`} className="ticketItem">
            <div className="number">
                {(props.data.status !== 'close' && props.data.status !== 'open') ?
                    <b className="statusbar"></b>
                    : null
                }
                <span>{props.data.id}</span>
            </div>
            <div className="ttl">
                <p>{props.data.title}</p>
            </div>
            <div className="date">
                <span>{props.data.jdate}</span>
            </div>
            <div className={`status ${props.data.status == 'close' ? 'closed' : props.data.status == 'open' ? '' : 'opened'}`}>
                <span>{props.data.status_message}</span>
            </div>
        </Link>
    )
}

export default TicketItem;